import React from 'react';
import { bool } from 'prop-types';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { s_lock } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

const PrivateBadge = ({ showLabel = true }) => (
    <Tooltip
        className="private-badge-tooltip"
        contentClassName="private-badge-tooltip-content"
        boxContentClassName="private-badge-tooltip-box"
        content={<I18n k="collections_perseus.private_list.tooltip" />}
        appendToBody={false}
    >
        <div className="private-badge tbody-6">
            <Icon className="lock-icon">{s_lock}</Icon>
            {showLabel && (
                <span className="label">
                    <I18n k="collections_perseus.private_list.title" />
                </span>
            )}
        </div>
    </Tooltip>
);

PrivateBadge.propTypes = {
    showLabel: bool,
};

export default PrivateBadge;
